import AlphaHelpers from './alpha-helpers'

export default class AlphaNotifier {
  init() {
    this._maybeInitToasts()
  }

  getConfig() {
    return {
      moduleName: 'notifier'
    }
  }

  getModuleManager() {
    return window.alpha
  }

  async addNotice(content, preset = 'default', options = {}) {
    const module = await this._getOrLoadModule()
    module.addNotice(content, preset, options)
  }

  /* INTERNAL METHODS */

  async _maybeInitToasts() {
    const toasts = AlphaHelpers.smartQuerySelectorAll('.toast')
    if (toasts.length) {
      const module = await this._getOrLoadModule()
      module._initToasts()
    }
  }

  _getOrLoadModule() {
    const config = this.getConfig()
    return this.getModuleManager().getOrLoadModule(config.moduleName)
  }
}
